// Central WhatsApp link builder — every WhatsApp entry point on the site
// goes through this helper so the message always carries page context
// (CLAUDE.md, section "WhatsApp-Links").

export const WHATSAPP_PHONE = '41762398070';
export const WHATSAPP_PHONE_DISPLAY = '+41 76 239 80 70';

/**
 * Build a wa.me deep link with a pre-filled, context-carrying message.
 *
 * @param {Object}  opts
 * @param {string}  [opts.source] Entry point id (`header`, `chat_widget`,
 *                  `contact_page`, `sticky_bar`, `detail_cta`). Not part of
 *                  the message — the analytics layer fires `whatsapp_click`
 *                  with this value separately.
 * @param {string}  [opts.title]  Listing title — when given, the message
 *                  references the object (detail pages).
 * @param {string}  [opts.url]    Full URL (detail pages) or pathname.
 * @returns {string} wa.me URL with encoded text.
 */
export function buildWhatsAppUrl({ source, title, url } = {}) {
  const message = title
    ? `Hallo! Ich interessiere mich für «${title}» (${url}).`
    : `Hallo! Ich schreibe von feelathomenow.ch (${url || '/'}).`;
  return `https://wa.me/${WHATSAPP_PHONE}?text=${encodeURIComponent(message)}`;
}
